<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <!-- <b-col cols="12" sm="6">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="From" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datefrom"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="From"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datefrom"
                        @click="datefrom = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="To" label-size="sm">
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="dateto"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="To"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!dateto"
                        @click="dateto = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Name" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="name"
                      :debounce="options.debounce"
                      placeholder="Name"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!name"
                        @click="name = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Category" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="category"
                      :debounce="options.debounce"
                      placeholder="Category"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!category"
                        @click="category = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Level" label-for="level" label-cols="12">
                  <treeselect
                    instanceId="level"
                    type="number"
                    v-model="level"
                    :clearable="false"
                    :options="level_options"
                  ></treeselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col
                  class="gridtoolbar"
                    cols="auto"
                    v-for="(tool, index) in tools.filter(
                      (o) => o.position == 'toolbar'
                    )"
                    :key="index"
                  >
                    <b-button
                      v-if="tool.type == 'button'"
                      :id="'tool_' + tool.action"
                      :size="tool.size"
                      :variant="tool.variant"
                      :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null"
                      :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)"
                    >
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col
                  cols="auto"
                  v-for="(tool, index) in options.view"
                  :key="index"
                >
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group
                    v-if="tool.type == 'radio-group'"
                    :options="tool.options"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>

        <div class="px-3">
          <b-overlay
            :show="options.overlay_show"
            rounded="sm"
            opacity="0.6"
            v-click-outside="outside"
          >
            <div>
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                :sticky-header="btable_height + 'px'"
                striped
                hover
                small
                caption-bottom
                selectable
                select-mode="multi"
                :busy="btable_busy"
                :items="btable_items"
                :filter="btable_find"
                :fields="options.fields"
                @row-selected="btable_rowSelected"
              >
                <template #head(selected)>
                  <i
                    id="selectall"
                    class="ml-1"
                    :class="btable_iconselected()"
                    aria-hidden="true"
                    @click="btable_iconselectedClick()"
                    title="Click to select/unselect all"
                  ></i>
                  <b-tooltip
                    target="selectall"
                    triggers="hover"
                    placement="right"
                    >Click to select/unselect all</b-tooltip
                  >
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      type="grow"
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        $helpers.badgeField(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in btable_rowActionCell(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="btable_rowClick(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="
                                    btable_rowActionIcon(action, row.item)
                                  "
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="btable_rowClick(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component
                      :is="options.component.name"
                      :selection="btable_selected"
                      :config="cconfig"
                      @discard="toolClick('discard')"
                      @refresh="toolClick('refresh')"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>
      <div v-if="component">
        <component
          :is="component"
          :selection="btable_selected"
          :config="cconfig"
          @saveit="saveit"
          @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"
        ></component>
      </div>
      <b-row class="excelsheetbuttons px-3" v-if="!component">
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary ml-1"
            >Found {{ btable_items.length }} rows</span
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";
import TaskView from "./Components/TaskView";

export default {
  name: "Tasks",
  components: { TaskView },
  watch: {
    async datefrom() {
      await this.load();
    },
    async dateto() {
      await this.load();
    },
    async name() {
      await this.load();
    },
    async category() {
      await this.load();
    },
    async level() {
      await this.load();
    },
  },
  data() {
    return {
      busy: false,
      datefrom: this.$moment().format("YYYY-MM-DD"),
      dateto: this.$moment().format("YYYY-MM-DD"),
      received_at: this.$moment().format("YYYY-MM-DD"),
      name: null,
      category: null,
      level: null,
      level_options: [
        { id: "0", label: "Information" },
        { id: "1", label: "Error" },
        { id: "2", label: "Warning" },
      ],
      options: {
        title: "Task Viewer",
        icon: "fa fa-tasks pl-2",
        debounce: 500,
        tools: [],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right",
          },
          {
            key: "level",
            label: "Level",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "created_at",
            label: "Received",
            class: "d-none d-sm-table-cell",
            sortable: true,
            // formatter: (value, key, item) => {
            //   let result = "Never";
            //   if (value) {
            //     result = this.$moment
            //       .unix(value / 1000)
            //       .format("DD/MM/YYYY HH:mm:SS");
            //   }
            //   return result;
            // },
          },
          {
            key: "name",
            label: "Event",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },

          {
            key: "category",
            label: "Category",
            sortable: true,
            sortDirection: "desc",
            type: "text",
          },
          {
            key: "data",
            type: "text",
            class: "text-left",
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = value.split("\n")[0];
              }
              return result;
            },
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          {
            key: "level",
            type: "badge",
            Information: "info",
            Error: "danger",
            Warning: "warning",
            formatter: (value, key, item) => {
              switch (parseInt(value)) {
                case 0:
                  return "Information";
                  break;
                case 1:
                  return "Error";
                  break;
                case 2:
                  return "Warning";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
        actions: [
          {
            key: "info",
            label: "Info",
            icon: "fa fa-expand",
            single: true,
            multiple: false,
            component: {
              name: "TaskView",
            },
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    // if (this.user.permissions.includes("clientemails.delete")) {
    this.options.actions.push({
      key: "delete",
      label: "Delete",
      icon: "fa fa-trash text-danger",
      single: true,
      multiple: true,
      overlay: {
        message: "Are you sure you want to delete row %id% ?",
        buttons: [
          {
            label: "Yes",
            variant: "danger",
            dispatch: "delete",
          },
          {
            label: "No",
            class: "ml-2",
          },
        ],
      },
    });
    // }

    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,add,import,archive");
    // this.loadDDL();
    this.load();
  },
  methods: {
    async load() {
      this.btable_items = [];
      this.btable_busy = true;

      let variables = {
        name: this.name,
        level: this.level,
        category: this.category,
        datefrom: this.datefrom,
        dateto: this.dateto,
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
            query tasks(
              $datefrom: String
              $dateto: String
              $name: String
              $category: String
              $level: String
              $data: String
              $created_at: String
            ) {
              tasks(
                datefrom: $datefrom
                dateto: $dateto
                name: $name
                category: $category
                level: $level
                data: $data
                created_at: $created_at
              ) {
                id
                name
                category
                level
                data
                created_at
              }
            }
          `,
          variables,
        });

        this.btable_items = response.data.tasks;
      } catch (error) {
        console.log(error);
      }

      this.btable_busy = false;
    },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "delete":
          await this.deleteit();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      switch (a) {
      }
    },
    async deleteit() {
      let variables = {
        rows: this.cleanit(this.selected),
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation deletetask($rows: [Task_input]) {
              deletetask(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },
  },
};
</script>

<style>
</style>